




















import { Component, Prop, Vue } from 'vue-property-decorator'
import { CARD_TYPE_DETAIL, formatDuration, normalizeSearch, plural } from '@/services/browse-and-go/labels'
import { merchantName } from '@/services/browse-and-go/store'
import { MultiChoiceCardModel } from '@/services/browse-and-go/types'

@Component({
  name: 'BrowseAndGoCardTile'
})
export default class extends Vue {
  @Prop({ required: true }) private card!: MultiChoiceCardModel

  get typeDetail() {
    return CARD_TYPE_DETAIL[this.card.type]
  }

  get duration() {
    return formatDuration(this.card.validityMonths)
  }

  get countLabel() {
    return plural(this.card.itemIds.length, 'élément', 'éléments')
  }

  get visualLabel() {
    const visual = (this.card.visual || '').trim()
    if (!visual) return ''
    if (normalizeSearch(visual).startsWith('visuel')) return visual
    return `Visuel : ${visual}`
  }

  get names() {
    return this.card.itemIds.map(id => merchantName(id))
  }

  get previewNames() {
    return this.names.slice(0, 6)
  }

  get extraCount() {
    return Math.max(this.names.length - this.previewNames.length, 0)
  }
}
